const rawWhatsApp = import.meta.env.VITE_WHATSAPP_NUMBER?.trim() || "6285141077960";
const whatsappNumber = rawWhatsApp.replace(/\D/g, "");
const instagramUrl = import.meta.env.VITE_INSTAGRAM_URL?.trim() || "https://www.instagram.com/morolab.id/";
const contactEmail = import.meta.env.VITE_CONTACT_EMAIL?.trim() || "morolab30s@gmail.com";
const googleFormUrl = import.meta.env.VITE_GOOGLE_FORM_URL?.trim()
  || "https://docs.google.com/forms/d/e/1FAIpQLSf0je1vr6_JtZNqVGv0E59_pWQp0Oq4X0B-lj08rs1AS6hG0g/viewform";

export const siteConfig = {
  googleFormUrl,
  attachmentsEnabled: import.meta.env.VITE_ENABLE_ATTACHMENTS === "true",
  whatsappUrl: whatsappNumber
    ? `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
        "Halo Morolab, saya ingin berkonsultasi tentang proyek 3D printing/desain.",
      )}`
    : "",
  instagramUrl,
  emailUrl: contactEmail ? `mailto:${contactEmail}` : "",
};
